import { render, staticRenderFns } from "./ViewActivitySurvey.vue?vue&type=template&id=2564b612&scoped=true"
import script from "./ViewActivitySurvey.vue?vue&type=script&lang=js"
export * from "./ViewActivitySurvey.vue?vue&type=script&lang=js"
import style0 from "./ViewActivitySurvey.vue?vue&type=style&index=0&id=2564b612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564b612",
  null
  
)

export default component.exports